import React from "react";
import "./Services.css";
import { motion } from "framer-motion";
import { useLocation, useNavigate } from "react-router-dom";
import Process from "../Process/Process";

import {
  FaMicrosoft,
  FaPrint,
  FaCalculator,
  FaShieldAlt,
  FaLaptopCode,
  FaProjectDiagram,
} from "react-icons/fa";

const coreServices = [
  {
    id: "microsoft",
    slug: "microsoft",
    title: "Microsoft",
    intro:
      "Microsoft 365, Azure, Dynamics 365 & Copilot – planned, deployed and supported.",
    icon: <FaMicrosoft />,
  },
  {
    id: "accounting",
    slug: "accounting-bookkeeping",
    title: "Accounting & Bookkeeping",
    intro:
      "US-focused bookkeeping, payroll and virtual CFO support for clean, tax-ready books.",
    icon: <FaCalculator />,
  },
  {
    id: "printer",
    slug: "printer-support",
    title: "Printer Support",
    intro:
      "Managed print, MFP setup and proactive support to keep your fleet online and compliant.",
    icon: <FaPrint />,
  },
  {
    id: "antivirus",
    slug: "antivirus-edr",
    title: "Antivirus & EDR",
    intro:
      "McAfee, Norton, Bitdefender and EDR stacks tuned for real-world US home & business use.",
    icon: <FaShieldAlt />,
  },
  {
    id: "webdev",
    slug: "web-development",
    title: "Web Development",
    intro:
      "Custom web apps, WordPress builds, SaaS MVPs and AI-powered features that actually ship.",
    icon: <FaLaptopCode />,
  },
  {
    id: "crm",
    slug: "crm-development",
    title: "CRM Development",
    intro:
      "Salesforce, HubSpot, Dynamics, Zoho and custom CRM setups wired for RevOps and reporting.",
    icon: <FaProjectDiagram />,
  },
];

const fadeCard = (i) => ({
  hidden: { opacity: 0, y: 28 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.06, duration: 0.45, ease: "easeOut" },
  },
});

const Services = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <>
      <section className="services-pro services-pro--brand">
        <div className="services-pro-inner">
          <div className="services-pro-header">
            <p className="services-pro-eyebrow">CORE SERVICE AREAS</p>
            <h2>
              One partner for{" "}
              <span>Microsoft, Finance, Security &amp; Growth</span>
            </h2>
            <p>
              From Microsoft and bookkeeping to printers, antivirus, web and
              CRM – each service is designed to plug into a connected,
              measurable stack.
            </p>
          </div>

          <div className="services-pro-grid">
            {coreServices.map((svc, i) => (
              <motion.article
                key={svc.id}
                className="services-pro-card"
                variants={fadeCard(i)}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.25 }}
                onClick={() => navigate(`/services/${svc.slug}`)}
                role="button"
                tabIndex={0}
              >
                <div className="services-pro-card-inner">
                  <div className="services-pro-card-top">
                    <div className="services-pro-icon">{svc.icon}</div>
                    <h3>{svc.title}</h3>
                  </div>

                  <p className="services-pro-text">{svc.intro}</p>

                  <button
                    type="button"
                    className="services-pro-link"
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate(`/services/${svc.slug}`);
                    }}
                  >
                    Explore <span aria-hidden="true">→</span>
                  </button>
                </div>
              </motion.article>
            ))}
          </div>
        </div>
      </section>

      {location.pathname === "/services" && <Process />}
    </>
  );
};

export default Services;
